// extracted by mini-css-extract-plugin
export default {"container":"CheckoutPage_container__JqZZl","message":"CheckoutPage_message__MxgsJ"};